export const formatCurrency = (amount: number): string => {
  return amount.toFixed(2);
};

export const formatDate = (timestamp: number): string => {
  return new Date(timestamp).toLocaleString();
};
